import './styles.scoped.css'

export default () => {
    return <div />
}
